import React from 'react'
import { Button } from '@apex/component-library'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Stack,
} from '@chakra-ui/react'

const PositiveActionModal = ({
  isOpen,
  onClose,
  putCaseAccept,
}: {
  isOpen: boolean
  onClose: () => void
  putCaseAccept: () => void
}) => {
  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Accept ACAT</ModalHeader>
        <ModalCloseButton />
        <ModalBody>Please confirm you want to accept this case.</ModalBody>
        <ModalFooter>
          <Stack direction="row" spacing={2}>
            <Button variant="white" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="positive"
              onClick={() => {
                onClose()
                putCaseAccept()
              }}
            >
              Accept
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default PositiveActionModal
